import styled from 'styled-components';

export const Wrapper = styled.div`
  padding: 7.3vh 0 0 0;
  height: 92.3vh;
  background-color: #fff;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #333;
  font-family: 'Pretendard Variable';
  font-size: 32px;
  font-style: normal;
  font-weight: 600;
  line-height: 150%;
  gap: 15px;
`;
